<ngb-accordion type="light" activeIds="static-1">
  <ngb-panel id="static-1" title="Environments">
    <ng-template ngbPanelContent>
      <app-tenant-environments [tenant]="tenant"></app-tenant-environments>
    </ng-template>
  </ngb-panel>
  <ngb-panel id="static-2" title="Tenant Identifiers">
    <ng-template ngbPanelContent>
      <app-tenant-identifiers [tenant]="tenant"></app-tenant-identifiers>
    </ng-template>
  </ngb-panel>
</ngb-accordion>
